import { render, staticRenderFns } from "./lawyer_box.vue?vue&type=template&id=72abd0ea&scoped=true"
import script from "./lawyer_box.vue?vue&type=script&lang=js"
export * from "./lawyer_box.vue?vue&type=script&lang=js"
import style0 from "./lawyer_box.vue?vue&type=style&index=0&id=72abd0ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72abd0ea",
  null
  
)

export default component.exports